import { handleReturnGameURL } from './common/utils';

import { Game } from '../../types';

const games: Game[] = [
  {
    name: 'Baccarat',
    src: {
      full: 'https://cdn.tain.com/demo/livecasino/high-quality/baccarat.png',
      thumbnail: 'https://cdn.tain.com/demo/livecasino/low-quality/baccarat.png'
    },
    modes: ['real'],
    method: handleReturnGameURL,
    urlData: {
      id: 'BAC',
      tableId: 'D055'
    }
  },
  {
    name: 'Blackjack',
    src: {
      full: 'https://cdn.tain.com/demo/livecasino/high-quality/blackjack.png',
      thumbnail: 'https://cdn.tain.com/demo/livecasino/low-quality/blackjack.png'
    },
    modes: ['real'],
    method: handleReturnGameURL,
    urlData: {
      id: 'BJ',
      tableId: 'D022'
    }
  },
  {
    name: 'Dragon Tiger',
    src: {
      full: 'https://cdn.tain.com/demo/livecasino/high-quality/dragontiger.png',
      thumbnail: 'https://cdn.tain.com/demo/livecasino/low-quality/dragontiger.png'
    },
    modes: ['real'],
    method: handleReturnGameURL,
    urlData: {
      id: 'DT',
      tableId: 'D060'
    }
  },
  {
    name: 'Roulette',
    src: {
      full: 'https://cdn.tain.com/demo/livecasino/high-quality/roulette.png',
      thumbnail: 'https://cdn.tain.com/demo/livecasino/low-quality/roulette.png'
    },
    modes: ['real'],
    method: handleReturnGameURL,
    urlData: {
      id: 'ROU',
      tableId: 'D001'
    }
  }
];

export default games;
